import { Injectable } from '@angular/core';
import { AccountListRequestModel } from '../business-entities/account-list-model';
import { AccountViewModel } from '../business-entities/account-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { AccountDataService } from '../data-services/account-data.service'

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  accountId: string;
  accountNo: string;
  accountName: string;
  customerId: string;

  accountListRequest: AccountListRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    isForDocuments: false,
    customerTypeId: 0,
    customerName: '',
    firstName: '',
    lastName: '',
    customerNo: '',
    customerGroup: null,
    salutation: null,
    postCode: null,
    city: null,
    email: '',
    mobile: '',
    licensePlateNo: '',
    statusId: 0,
    syncId: 0,
    sourceOfCreation: '',
    registrationOrPersonNumber: ''
  }

  constructor(private accountsDataService: AccountDataService) { }

  async getAccountList(requestModel: AccountListRequestModel): Promise<GenericResponse<any>> {
    return this.accountsDataService.getAccountList(requestModel);
  }

  async getAccountDetailsById(id: string): Promise<AccountViewModel> {
    let  response: AccountViewModel;
        await this.accountsDataService
            .getAccountDetailsById(id)
            .then(
                (res: GenericResponse<any>) => {
                    response = res.responseObject;
                }
            );
        return response;
  }

  async getContactDetailsById(id: string, startRecordNumber: number, numberOfRecord: number): Promise<GenericResponse<any>> {
    return this.accountsDataService.getContactDetailsById(id, startRecordNumber, numberOfRecord);
  }
}
